// removed by extract-text-webpack-plugin
module.exports = {"eta":"ETA-module__eta___13O57","info":"ETA-module__info___3z-bq","title":"ETA-module__title___3G4kb","time":"ETA-module__time___29XB5","icon":"ETA-module__icon___1jlE9","mobile":"ETA-module__mobile___39GK7"};


//////////////////
// WEBPACK FOOTER
// ./src/js/widgets/Status/ETA.module.scss
// module id = 319
// module chunks = 0 1